import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '@/utils/axios'
import router from '@/router'

const FILE_BASE = String(import.meta.env.VITE_FILE_BASE_URL || '').replace(/\/$/, '')
const DEFAULT_AVATAR = '/default-avatar.png'

function resolveAvatar(file_user) {
  if (!file_user) return DEFAULT_AVATAR
  
  // Jika URL sudah absolut, langsung return
  if (file_user.startsWith('http://') || file_user.startsWith('https://')) {
    return file_user
  }
  
  // Jika storage path, gabung dengan FILE_BASE
  return `${FILE_BASE}/${file_user.replace(/^\/storage\//, '')}`
}

export const useAuthStore = defineStore("auth", () => {
  const user = ref(null)
  const token = ref(localStorage.getItem("token"))
  const loading = ref(false)

  // Perbaikan: computed property yang memeriksa token dan user
  const isLoggedIn = computed(() => Boolean(token.value && user.value?.id))

  const hasPermission = (permissionName) => {
    if (!isLoggedIn.value || !Array.isArray(user.value?.permissions)) return false
    return user.value.permissions.includes(permissionName)
  }

const setUser = (userData) => {
  if (!userData) {
    user.value = null
    localStorage.removeItem('user')
    return
  }

  const raw = Array.isArray(userData) ? userData[0] : userData
  
  // Simpan file_user original dari API
  const avatar_url = raw.file_user || raw.avatar || raw.photo || null
  console.log('[auth] Raw avatar URL:', avatar_url)
  
  user.value = {
    id: raw.id || raw.user_id || raw.id_user || null,
    name: raw.name || raw.nama || raw.username || null,
    email: raw.email || null,
    file_user: avatar_url, // simpan URL original
    permissions: Array.isArray(raw.permissions) ? raw.permissions : [],
    roles: Array.isArray(raw.roles) ? raw.roles : [],
    ...raw
  }

  console.log('[auth] Resolved avatar:', resolveAvatar(avatar_url))
  localStorage.setItem("user", JSON.stringify(user.value))
}
  

// ...existing code...
const initSession = async () => {
  const storedToken = localStorage.getItem("token")
  console.log('[auth] initSession start', { storedTokenExists: !!storedToken })
  if (!storedToken) return false

  token.value = storedToken
  api.defaults.headers.common.Authorization = `Bearer ${storedToken}`
  console.log('[auth] Authorization header set')

  try {
    // Pertama ambil list user untuk dapat ID
    const { data: listData } = await api.get("/publik/user-me")
    console.log('[auth] /publik/user-me list response', listData)
    
    if (!listData?.status || !Array.isArray(listData?.data)) {
      throw new Error('Invalid user list response')
    }

    // Ambil ID user pertama dari list
    const userId = listData.data[0]?.id
    if (!userId) throw new Error('User ID not found')

    // Kemudian ambil detail user dengan ID tersebut
    const { data: detailData } = await api.get(`/publik/user-me/${userId}`)
    console.log('[auth] /publik/user-me/:id response', detailData)

    if (detailData?.status && detailData?.data) {
      setUser(detailData.data) // ini akan berisi file_user yang benar
      return true
    }
    throw new Error('Invalid user detail data')
  } catch (error) {
    console.error('[auth] initSession error:', error)
    token.value = null
    user.value = null
    localStorage.removeItem("token")
    localStorage.removeItem("user")
    return false
  }
}

  // ...existing code...

const login = async (credentials) => {
  loading.value = true;
  try {
    console.log('[auth] login attempt');
    const { data } = await api.post("/auth/login", credentials);
    
    if (!data?.token) {
      throw new Error('No token received');
    }

    // Set token first
    token.value = data.token;
    localStorage.setItem("token", data.token);
    api.defaults.headers.common.Authorization = `Bearer ${data.token}`;

    // Ambil detail user dengan ID yang benar
    const userId = data.user?.id || data.data?.id;
    if (!userId) throw new Error('User ID not found in login response');

    // Fetch detail user untuk dapat avatar
    const { data: detailData } = await api.get(`/publik/user-me/${userId}`);
    console.log('[auth] User detail after login:', detailData);

    if (detailData?.status && detailData?.data) {
      setUser(detailData.data);
      console.log('[auth] login success with avatar', { 
        id: user.value?.id, 
        name: user.value?.name,
        avatar: user.value?.file_user 
      });
    } else {
      throw new Error('Failed to get user details');
    }

    return { success: true };
  } catch (error) {
    console.error('[auth] login failed:', error);
    token.value = null;
    user.value = null;
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    delete api.defaults.headers.common.Authorization;
    throw error;
  } finally {
    loading.value = false;
  }
};

// ...existing code...
  const logout = () => {
    token.value = null
    user.value = null
    localStorage.removeItem("token")
    localStorage.removeItem("user")
    delete api.defaults.headers.common.Authorization
    router.replace({ name: "Login" })
  }

  return {
    user,
    token,
    loading,
    isLoggedIn,
    hasPermission,
    setUser,
    initSession,
    logout,
    login,
  }
})